import { stylesMode } from '../../styles';

// ----------------------------------------------------------------------

// Dabang's surface: a wide, near-white blur that separates a white card from the #F7FAFC
// canvas without a border. It's `shadows[1]` in the template's own custom shadow array.
export const dabangElevation1 = '0px 4px 20px 0px rgba(238,238,238,0.5)';

// The same shape in dark mode, where a near-white blur would read as a halo.
export const dabangElevation1Dark = '0px 4px 20px 0px rgba(0,0,0,0.32)';

// Dabang's Paper is `shape.borderRadius * 5` = 20px. Held back to 16 here: these cards hold
// full-height data grids, and at 20 the curve starts eating the first and last row's cells.
export const CARD_RADIUS = 16;

const MuiCard = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: ({ theme }) => ({
      position: 'relative',
      boxShadow: dabangElevation1,
      borderRadius: CARD_RADIUS,
      zIndex: 0, // Fix Safari overflow: hidden with border radius
      [stylesMode.dark]: { boxShadow: dabangElevation1Dark },
    }),
  },
};

// ----------------------------------------------------------------------

const MuiCardHeader = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: {
    titleTypographyProps: { variant: 'h6' },
    subheaderTypographyProps: { variant: 'body2', marginTop: '4px' },
  },

  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(3, 3, 0),
    }),
  },
};

// ----------------------------------------------------------------------

const MuiCardContent = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: { root: ({ theme }) => ({ padding: theme.spacing(3) }) },
};

// ----------------------------------------------------------------------

export const card = { MuiCard, MuiCardHeader, MuiCardContent };
